import React from 'react';
import styles from './Footer.module.css';

/**
 * Footer — Shared footer rendered at the bottom of every section.
 * SEO: Crawlable phone number, WhatsApp link, proper landmark structure.
 */

const quickLinks = [
  { id: 'puja', label: 'Puja Services', icon: '🕉️' },
  { id: 'mantras', label: 'Mantras', icon: '📿' },
  { id: 'reviews', label: 'Reviews', icon: '⭐' },
  { id: 'customers', label: 'Our Jajmaan', icon: '👥' },
  { id: 'booking', label: 'Book Now', icon: '📅' },
];

export default function Footer({ onNavigate }) {
  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={styles.footerGrid}>
        {/* Brand */}
        <div className={styles.brand}>
          <div className={styles.brandLogo}>
            <div className={styles.logoIcon}>ॐ</div>
            <span className={styles.brandName}>PanditJi.space</span>
          </div>
          <p className={styles.brandDesc}>
            Your trusted platform for online pandit booking, authentic puja services,
            sacred mantras, and spiritual guidance. Book a pandit for wedding, griha pravesh,
            satyanarayan katha, havan, mundan, and all Hindu rituals —
            bringing divine blessings to your doorstep across India.
          </p>
        </div>

        {/* Quick Links */}
        <nav className={styles.footerColumn} aria-label="Quick Links">
          <span className={styles.columnTitle}>Quick Links</span>
          {quickLinks.map((link) => (
            <button
              key={link.id}
              className={styles.footerLink}
              onClick={() => onNavigate(link.id)}
              id={`footer-nav-${link.id}`}
            >
              <span className={styles.linkIcon}>{link.icon}</span>
              {link.label}
            </button>
          ))}
        </nav>

        {/* Contact — crawlable text for SEO */}
        <div className={styles.footerColumn}>
          <span className={styles.columnTitle}>Contact Us</span>
          <a href="tel:+919022717632" className={styles.contactItem} id="footer-phone-link">
            <span className={styles.contactIcon}>📞</span>
            +91 9022717632
          </a>
          <a
            href="https://wa.me/919022717632?text=I%20want%20to%20book%20a%20pandit"
            className={styles.contactItem}
            target="_blank"
            rel="noopener noreferrer"
            id="footer-whatsapp-link"
          >
            <span className={styles.contactIcon}>📱</span>
            WhatsApp Us
          </a>
          <div className={styles.contactItem}>
            <span className={styles.contactIcon}>📍</span>
            Naigaon, Mumbai, India
          </div>
        </div>
      </div>

      <div className={styles.footerDivider} />

      <div className={styles.footerBottom}>
        <span className={styles.copyright}>
          © {new Date().getFullYear()} PanditJi.space — All rights reserved
        </span>
        <div className={styles.socials}>
          <a href="https://www.facebook.com/panditji.space" className={styles.socialLink} aria-label="Facebook" target="_blank" rel="noopener noreferrer" id="footer-facebook-link">f</a>
          <a href="https://www.instagram.com/anuj_pandey.2?igsh=NjF6YWV4MDR0dXV6" className={styles.socialLink} aria-label="Instagram" target="_blank" rel="noopener noreferrer" id="footer-instagram-link">📸</a>
        </div>
      </div>
    </footer>
  );
}
